module.exports = __webpack_public_path__ + "static/media/logo-demervallobao.b112f0e8.png";